export const MODULE_NAME = 'autocomplete';

const prefix = `${MODULE_NAME}/`;

export const ACTION_TYPES = {
    AUTOCOMPLETE_FETCHED: `${prefix}AUTOCOMPLETE_FETCHED`,
    CLEAR_AUTOCOMPLETE: `${prefix}CLEAR_AUTOCOMPLETE`
};
